module.exports = __webpack_public_path__ + "img/mathematics.8fbe9b5a.svg";